/** Single source of truth for public branding (owner decision 2026-07-17). */
export const BRAND_NAME = 'AIFin Sentiment';
export const SUPPORT_EMAIL = 'support@aifinsentiment.com';
/** Owner-approved free tier (ADR 0008): three popular S&P 500 tickers. */
export const FREE_TICKERS = ['AAPL', 'NVDA', 'GOOGL'] as const;
/**
 * The date paid plans launch and the beta ends (owner decision 2026-09-28).
 * Shown wherever billing is not yet available.
 */
export const PAID_PLANS_LAUNCH = 'October 28, 2026';
